import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const BASE = 'https://evercorenutrition.com/ev_admin/api';

export const fetchOrders = createAsyncThunk('orders/fetch', async (customerId, { rejectWithValue }) => {
  try {
    const res = await fetch(`${BASE}/orders/?customer_id=${customerId}`);
    if (!res.ok) throw new Error('Failed');
    return await res.json();
  } catch (e) {
    return rejectWithValue(e.message);
  }
});

export const cancelOrder = createAsyncThunk('orders/cancel', async (orderId, { rejectWithValue }) => {
  try {
    const res = await fetch(`${BASE}/orders/${orderId}/cancel/`, { method: 'POST' });
    if (!res.ok) throw new Error('Failed');
    return orderId;
  } catch (e) {
    return rejectWithValue(e.message);
  }
});

export const trackOrder = createAsyncThunk('orders/track', async ({ orderId, customerId }, { rejectWithValue }) => {
  try {
    const res = await fetch(`${BASE}/orders/${orderId}/track/?customer_id=${customerId}`);
    if (!res.ok) throw new Error('Failed');
    return await res.json();
  } catch (e) {
    return rejectWithValue(e.message);
  }
});

const ordersSlice = createSlice({
  name: 'orders',
  initialState: { list: [], trackingInfo: null, loading: false, trackLoading: false, error: null },
  reducers: {
    clearTracking: (state) => { state.trackingInfo = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => { state.loading = true; })
      .addCase(fetchOrders.fulfilled, (state, action) => { state.loading = false; state.list = action.payload; })
      .addCase(fetchOrders.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(cancelOrder.fulfilled, (state, action) => {
        const idx = state.list.findIndex((o) => o.id === action.payload || o.order_id === action.payload);
        if (idx !== -1) state.list[idx].status = 'Cancelled';
      })
      .addCase(trackOrder.pending, (state) => { state.trackLoading = true; })
      .addCase(trackOrder.fulfilled, (state, action) => { state.trackLoading = false; state.trackingInfo = action.payload; })
      .addCase(trackOrder.rejected, (state) => { state.trackLoading = false; });
  },
});

export const { clearTracking } = ordersSlice.actions;
export default ordersSlice.reducer;